/**
 * Interactivity for the desktop navigation.
 * The UX allows the user to click open the sub menus via the tier 1
 * menu links. From there they can click the other tier 1 links
 * to see those sub menus, or close out the sub menus altogether
 * by using the close button or clicking the active tier 1 link again.
 *
 * @author Todd Miller <github.com/Toddses>
 */

(function ($, once) {
  'use strict';

  const $menuSpeed = 300;

  let $closers;
  let $menuItems;
  let menuOpen;
  let $dropdownLinks;
  let $dropdownMenus;

  Drupal.behaviors.initializeDesktopNav = {
    attach: (context) => {
      once('initializeDesktopNav', 'html').forEach(function (element) {
        initialize();
      });
    },
  };

  /**
   * User clicked on a tier 1 menu item. Toggle the menu state.
   * Also toggle hover events so as the user hovers over menu
   * items the sub menu changes to accommodate.
   */
  function handleClick(e) {
    e.preventDefault();

    const $el = $(e.currentTarget);

    if (menuOpen) {
      if ($el.hasClass('is-open')) {
        $el.removeClass('is-open');
        menuOpen = false;
      } else {
        $menuItems.addClass('no-transition').removeClass('is-open');
        $el.addClass('is-open');
        menuOpen = true;

        setTimeout(() => {
          $menuItems.removeClass('no-transition');
          closeAllDropdownMenus();
        }, $menuSpeed);
      }
    } else {
      closeAllDropdownMenus();
      $el.addClass('is-open');
      menuOpen = true;
    }
  }

  /**
   * User click the close button so shut it all down.
   */
  function handleClose(e) {
    e.stopPropagation();
    $menuItems.removeClass('is-open');
    menuOpen = false;

    closeAllDropdownMenus();
  }

  /**
   * Toggle dropdown for a tier 2 menu item.
   */
  function setupDropdownMenus() {
    $dropdownMenus = $(
      '#block-barksdale-main-menu .menu-level-1 .menu-item--expanded'
    );
    $dropdownLinks = $dropdownMenus.find('> a');

    // Stop if there are no dropdown menu items, nothing else to do.
    if (!$dropdownMenus) return false;

    $dropdownLinks.on('click', handleDropdownToggle);
  }

  /**
   * User clicks a link with a menu below it.
   */
  function handleDropdownToggle(e) {
    e.preventDefault();

    const $el = $(e.currentTarget);

    let $thisMenu = $el.siblings('.menu-dropdown');

    if ($thisMenu.hasClass('is-open')) {
      $thisMenu.slideUp($menuSpeed);
    } else {
      $thisMenu.slideDown($menuSpeed);
      // Close open sibling menus.
      let $openSiblings = $thisMenu
        .parent()
        .siblings('.menu-item--expanded')
        .find('.menu-dropdown.is-open');
      $openSiblings.slideToggle($menuSpeed);
      $openSiblings.removeClass('is-open');
    }

    $thisMenu.toggleClass('is-open');
  }

  /**
   * Close all open menus.
   */
  function closeAllDropdownMenus() {
    let $openMenus = $dropdownMenus.find('.menu-dropdown.is-open');
    $openMenus.removeClass('is-open');
    // Delay closing so the main menu closes with dropdowns in the same position
    $openMenus.delay($menuSpeed).slideToggle(0);
  }

  /**
   * Cache elements, intialize variables and event handlers.
   */
  function initialize() {
    $menuItems = $(
      '#block-barksdale-main-menu > ul > li.menu-item--expanded > a'
    );

    // If for some weird reason there are no main menu links on the page,
    // get out here so it doesn't crash later.
    if (!$menuItems.length) return false;

    $closers = $('#block-barksdale-main-menu .sub-menu .close-button');
    menuOpen = false;

    $closers.on('click', handleClose);
    $menuItems.on('click', handleClick);

    setupDropdownMenus();
  }
})(jQuery, once);
